import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Principal } from 'src/app/models/principal/principal';
import { Permission } from 'src/app/models/principal/permission';
import { KeyValueMap } from '../../../models/key-value-map';
import { PermissionsService } from '../../../services/util/permissions.service';
import { RouterSegments } from '../../../models/router-segments';
import { MatMenu } from '@angular/material/menu';
import { Authority } from 'src/app/models/principal/authority';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    standalone: false
})
export class UserMenuComponent implements OnInit, AfterViewInit {

  @ViewChild('userMenu', { static: true }) private userMenu: MatMenu;

  tenant: string;
  principal: Principal;
  principalAbbreviation: string;
  permissionsMap: KeyValueMap<string, boolean>;

  Permission = Permission;
  RouterSegments = RouterSegments;
  authorizedUser: any;

  constructor(private authService: AuthService, private permissionsService: PermissionsService) { }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.principal = this.authService.principal;
    this.authorizedUser = this.principal?.authorities?.find((item) => item === Authority.OPERATION_MANAGER
    || item === Authority.SERVICE_MANAGER);
    this.principalAbbreviation = this.getNameAbbreviation(this.authService.principal);
  }

  ngAfterViewInit(): void {
    this.userMenu.overlayPanelClass = 'user-menu-overlay-panel';
  }

  logout(): void {
    this.authService.logout();
  }

  private getNameAbbreviation(principal: Principal): string {
    // Does a possibility to not have first and last name exist?
    return principal?.attributes?.given_name.substr(0, 1).toUpperCase()
      + principal?.attributes?.family_name.substr(0, 1).toUpperCase();
  }
}
